import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { site } from '../content/site';

const LINKS = [
  { to: '/resume', label: 'Resumé' },
  { to: '/contact', label: 'Contact' },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Close the mobile menu whenever the route changes.
  useEffect(() => setOpen(false), [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-cream/85 shadow-soft backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      {/*
        Full bleed: no max width and no centering, so the bar frames the page rather than sitting
        inside the content column with it. The padding stays - it is what keeps her mark and the
        links off the edge of the glass.
      */}
      <nav
        aria-label="Main"
        className="flex items-center justify-between px-5 py-3 sm:px-8"
      >
        <Link to="/" className="flex items-center" aria-label={`${site.name} — home`}>
          {/* Her own hand-drawn mark, which the old site never used. */}
          <img
            src="/images/signature.png"
            alt=""
            width={1340}
            height={523}
            className="h-10 w-auto sm:h-11"
          />
          <span className="sr-only">{site.name}</span>
        </Link>

        <ul className="hidden items-center gap-2 md:flex">
          {LINKS.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                className={({ isActive }) =>
                  `rounded-full px-5 py-2.5 font-display text-base font-semibold transition-colors duration-200 ${
                    isActive
                      ? 'bg-mint-100 text-mint-800'
                      : 'text-mint-800 hover:bg-mint-50 hover:text-mint-900'
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
          aria-controls="mobile-nav"
          className="rounded-full p-2.5 text-mint-800 transition-colors hover:bg-mint-50 md:hidden"
        >
          <span className="sr-only">{open ? 'Close menu' : 'Open menu'}</span>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            {open ? (
              <path
                d="M6 6l12 12M18 6L6 18"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              />
            ) : (
              <path
                d="M4 7h16M4 12h16M4 17h16"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
              />
            )}
          </svg>
        </button>
      </nav>

      <div
        id="mobile-nav"
        hidden={!open}
        className="mx-4 mb-3 rounded-3xl bg-white/95 p-2 shadow-soft backdrop-blur md:hidden"
      >
        <ul className="flex flex-col">
          {LINKS.map((link) => (
            <li key={link.to}>
              <NavLink
                to={link.to}
                className={({ isActive }) =>
                  `block rounded-2xl px-5 py-3.5 font-display text-base font-semibold ${
                    isActive ? 'bg-mint-100 text-mint-800' : 'text-mint-800 hover:bg-mint-50'
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}
